module.exports = __webpack_public_path__ + "static/img/29.4e30306a.png";